import React, { useState, useEffect } from 'react';
import { X, ChevronDown, ChevronUp, Zap, Star, Bell, Shield, BarChart3, Users, FileText, Settings, Heart, Award, Lightbulb, Package, Sparkles, Clock } from 'lucide-react';;
import api from '../../services/api';

const ICON_MAP = { Zap, Star, Bell, Shield, BarChart3, Users, FileText, Settings, Heart, Award, Lightbulb, Package, Sparkles, Clock };
const IconComponent = ({ name, className }) => {
  const Icon = ICON_MAP[name] || Zap;
  return <Icon className={className} />;
};

const WhatsNewBanner = ({ user }) => {
  const [release, setRelease] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!user?.id) return;
    const t = setTimeout(async () => {
      try {
        const res = await api.get('/whats-new/current');
        if (res.data?.release && !res.data.dismissed) {
          setRelease(res.data.release);
          setVisible(true);
        }
      } catch { /* silent */ }
    }, 1000);
    return () => clearTimeout(t);
  }, [user?.id]);

  const dismiss = async () => {
    setVisible(false);
    try { await api.post('/whats-new/dismiss'); } catch { /* silent */ }
  };

  if (!visible || !release) return null;

  return (
    <div className="animate-fade-in bg-primary">
      {/* Compact bar */}
      <div className="flex items-center gap-3 px-4 py-2.5">
        <div className="flex items-center gap-1.5 shrink-0">
          <Sparkles className="w-3.5 h-3.5 text-white/80" />
          <span className="text-xs font-semibold text-white uppercase tracking-widest">
            {release.title}
          </span>
        </div>
        <div className="flex-1" />
        <div className="flex items-center gap-1 shrink-0">
          <button
            onClick={() => setExpanded(e => !e)}
            className="flex items-center gap-1 text-xs text-white/80 hover:text-white font-medium transition-colors px-2 py-1 rounded hover:bg-white/10"
          >
            {expanded ? 'Hide' : `See details (${release.features?.length || 0})`}
            {expanded ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
          </button>
          <button
            onClick={dismiss}
            className="p-1 rounded hover:bg-white/10 text-white/70 hover:text-white transition-colors"
            title="Dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      </div>

      {/* Expanded feature list */}
      {expanded && (
        <div className="px-4 pb-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 border-t border-white/20 pt-3">
          {(release.features || []).map((f, i) => (
            <div key={f.id || i} className="flex items-start gap-3 p-2.5 bg-secondary rounded-lg">
              <div className="w-7 h-7 rounded-md bg-primary/10 flex items-center justify-center shrink-0 mt-0.5">
                <IconComponent name={f.icon} className="w-3.5 h-3.5 text-primary" />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-semibold leading-tight text-foreground">{f.title}</p>
                <p className="text-[11px] text-muted-foreground mt-0.5 leading-relaxed">{f.description}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WhatsNewBanner;
